import MuiPopover, { PopoverProps as MuiPopoverProps } from '@mui/material/Popover';

export const Popover = (props: MuiPopoverProps): JSX.Element => {
  return <MuiPopover {...props} />;
};
